<template>
  <fullscreen-overlay-frame :title="$t('schedule-overview-dialog.title').toString()"
                            icon="schedule"
                            color="primary"
                            centered
                            closable
                            maximizable
                            @close="close"
                            @maximize="maximize"
                            @minimize="minimize">
    <template v-slot:content>
      <div v-show="schedules.length < 1" class="empty-state-container">
        <div>
          <schedule-overview-empty-state/>
          <h3 class="my-2 primary--text" v-html="$t('schedule-overview-dialog.description.title')"></h3>
          <div class="mb-5" v-html="$t('schedule-overview-dialog.description.content')"></div>
        </div>
      </div>
      <content-card :title="$t('schedule-overview-dialog.list.title')"
                    icon="schedule"
                    v-show="schedules.length > 0">
        <template v-slot:titleBar>
          <v-icon class="add_location_icon material-icons-outlined"
                  color="primary" @click="newSchedule">
            add_circle
          </v-icon>
        </template>
        <template v-slot:content>
          <active-day-overview :weekdays="weekdays"/>
          <v-list>
            <div>
              <v-list-item class="mx-2" v-for="(schedule, i) in schedules"
                           :key="i" @click="openSchedule(schedule)">
                <v-list-item-icon>
                  <v-chip class="heating-scene-color-chip mt-1"
                          :color="schedule.scheduleAdditionalInformation.color"></v-chip>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ schedule.scheduleAdditionalInformation.title }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon color="primary" @click.stop="openSchedule(schedule)">edit</v-icon>
                  <v-switch class="mt-0 pr-5"
                            v-model="schedule.schedule.isEnabled"
                            :loading="togglingSchedule"
                            inset hide-details
                            @click.stop="toggleSchedule(schedule)"/>
                </v-list-item-action>
              </v-list-item>
            </div>
          </v-list>
        </template>
      </content-card>
    </template>
    <template v-slot:actions>
      <div v-show="schedules.length < 1" class="new-schedule-button-container">
        <v-btn class="mb-4 font-weight-bold"
            color="primary"
               @click="newSchedule()"
               depressed large>
          <v-icon>add</v-icon>
          {{ $t('schedule-overview-dialog.new-schedule') }}
        </v-btn>
      </div>
    </template>
  </fullscreen-overlay-frame>
</template>

<script>
import FullscreenOverlayFrame from "@/templates/dialogs/FullscreenOverlayFrame.vue";
import ContentCard from "@/templates/components/ContentCard.vue";
import store from "enode-lib/src/store";
import {createEnodeLib} from "@/plugins/enodePlugin";
import ScheduleOverviewEmptyState from "@/assets/images/schedule_overview_empty_state.vue";

export default {
  components: {
    ScheduleOverviewEmptyState,
    ContentCard,
    FullscreenOverlayFrame
  },
  props: ['data'],
  data() {
    return {
      store: store,
      enodeLib: createEnodeLib(),
      weekdays: [[], [], [], [], [], [], []],
      togglingSchedule: false,
    }
  },
  methods: {
    /**
     * maximize dialog
     */
    maximize() {
      this.fullscreen = true
      this.$emit('maximize')
    },

    /**
     * minimize dialog
     */
    minimize() {
      this.fullscreen = false
      this.$emit('minimize')
    },

    /**
     * close dialog
     */
    close() {
      this.$root.bisadialog.toggle('scheduleOverview')
    },
    newSchedule() {
      this.$root.bisadialog.toggle('schedule', true, {
        vehicleId: this.data.vehicleId,
        smartChargingEnabled: this.data?.smartChargingEnabled,
        greenChargingActive: this.data?.greenChargingActive
      })
      this.$root.bisadialog.callDialogInit('schedule')
      this.close()
    },
    openSchedule(schedule) {
      this.$root.bisadialog.toggle('schedule', true, {
        vehicleId: this.data.vehicleId,
        schedule: schedule,
        smartChargingEnabled: this.data?.smartChargingEnabled,
        greenChargingActive: this.data?.greenChargingActive
      })
      this.$root.bisadialog.callDialogInit('schedule')
      this.close()
    },
    toggleSchedule(schedule) {
      this.togglingSchedule = true
      this.enodeLib.updateSchedule(schedule).then(() => {
        this.submitting = false
        this.enodeLib.fetchUserSchedules().then(() => {
          this.togglingSchedule = false
        })
      }).catch((error) => {
        console.error('Error updating schedule', error)
        this.togglingSchedule = false
      })
    }
  },
  computed: {
    schedules() {
      return store.sharedState.schedules.filter(schedule => schedule.schedule.targetId === this.data.vehicleId)
    },
  }
}
</script>

<style lang="scss">
@import '~@/styles/schedule-overview-dialog.scss';
@import '~@/styles/living/e-mobility.scss';
</style>